<template>
    <v-container fluid>
        <v-layout>
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-card-text>
                        <!-- <img src="@/assets/LOGO_HZD_Digital_curvas.svg" height="80px" class="logo"> -->
                        <img src="@/assets/proton.svg" height="80px" class="logo">
                        <v-layout row wrap>
                            <v-flex xs12 mx-3>
                                <v-flex xs12 class="text-xs-center" mt-2>
                                    <h4>Introduzca su email:</h4>
                                </v-flex>
                                <form @submit.prevent="userLostPassword">
                                    <v-layout column>
                                        <v-flex>
                                            <v-alert type="error" dismissible v-model="alert">
                                                {{ error }}
                                            </v-alert>
                                            <v-alert type="success" dismissible v-model="info">
                                                {{ message }}
                                            </v-alert>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field :class="{ 'input-group--dirty': true }" name="email" label="Email" id="email" type="email" v-model="email" required></v-text-field>
                                        </v-flex>

                                        <v-flex class="text-xs-center" mt-3>
                                            <v-btn :loading="loading" :disabled="loading" color="primary" type="submit">Enviar</v-btn>
                                        </v-flex>
                                        <v-flex>
                                            <router-link to="/signin">regresar al inicio de sesion</router-link>
                                        </v-flex>
                                    </v-layout>
                                </form>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      alert: false,
      info: false
    };
  },
  methods: {
    userLostPassword() {
      this.alert = false;
      this.$store.dispatch("userLostPassword", {
        email: this.email
      });
    }
  },
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    },
    message() {
      return this.$store.state.message;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    },
    info(value) {
      if (!value) {
        this.$store.commit("setMessage", null);
      }
    },
    message(value) {
      if (value) this.info = true;
      this.email = "";
      const ref = this;
      setInterval(() => {
        ref.info = false;
      }, 5000);
    }
  }
};
</script>

<style scoped>
.logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
</style>